import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initCatalogSlider = function() {
  const changeSlideHover = function(elem) {
    if (elem) {
      elem.forEach(el => el.addEventListener('mouseover', (event) => {
        el.click();
      }));
    }
  }

  const slidersCatalogResult = document.querySelectorAll('[data-slider-catalog]');
  if (slidersCatalogResult.length > 0) {
    slidersCatalogResult.forEach((slider) => {

      new Swiper(slider, {
        spaceBetween: 10,
        slidesPerView: 1,
        // mousewheelControl: true,
        // mousewheel: {
        //   releaseOnEdges: true,
        // },
        pagination: {
          el: slider.querySelector('[data-slider-catalog-pagination]'),
          clickable: true,
          bulletActiveClass: 'is-active',
          bulletClass: 'card__pagination-btn pagination__btn',
          renderBullet(index, className) {
            return '<button class="' + className + '" type="button" aria-label="Перейти на ' + (index + 1) + ' слайд"></button>';
          }
        },
        on: {
          init: function() {
            const slideBulletBtn = document.querySelectorAll('.card__pagination-btn');
            changeSlideHover(slideBulletBtn);
          }
        }
      });
    })
  }

  const sliderSampleAnalog = document.querySelector('[data-sample-analog="slider"]');
  if (sliderSampleAnalog) {
    const swiperSampleAnalog = function() {
      new Swiper(sliderSampleAnalog, {
          spaceBetween: 10,
          slidesPerView: 2,
          slidesPerGroup: 2,
          // autoHeight: true,
          mousewheelControl: true,
          mousewheel: {
            releaseOnEdges: true
          },
          pagination: {
            el: '[data-sample-analog=\'pagination\']',
            clickable: true,
            bulletActiveClass: 'is-active',
            bulletClass: 'catalog__watched-btn pagination__btn',
            renderBullet(index, className) {
              return '<button class="' + className + '" type="button" aria-label="Перейти на ' + (index + 1) + ' слайд"></button>';
            }
          },
          navigation: {
            nextEl: '[data-sample-analog="arrow-next"]',
            prevEl: '[data-sample-analog="arrow-prev"]'
          },
          breakpoints: {
            360: {
              slidesPerView: 2,
              slidesPerGroup: 2
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 12,
              slidesPerGroup: 1
            },
            1500: {
              slidesPerView: 4,
              spaceBetween: 30
            }

          }
        }
      );
    }
    swiperSampleAnalog();
  }

  const sliderSampleGoods = document.querySelectorAll('[data-sample-goods="slider"]');
  if (sliderSampleGoods.length > 0) {
    sliderSampleGoods.forEach((sliderParent) => {
      const slider = sliderParent.querySelector('.swiper');
      const pagination = sliderParent.querySelector('[data-sample-goods="pagination"]');
      const btnPrev = sliderParent.querySelector('[data-sample-goods="arrow-prev"]');
      const btnNext = sliderParent.querySelector('[data-sample-goods="arrow-next"]');
      new Swiper(slider, {
          spaceBetween: 10,
          slidesPerView: 2,
          // slidesPerGroup: 2,
          // autoHeight: true,
          mousewheelControl: true,
          mousewheel: {
            releaseOnEdges: true
          },
          pagination: {
            el: pagination,
            clickable: true,
            bulletActiveClass: 'is-active',
            bulletClass: 'catalog__watched-btn pagination__btn',
            renderBullet(index, className) {
              return '<button class="' + className + '" type="button" aria-label="Перейти на ' + (index + 1) + ' слайд"></button>';
            }
          },
          navigation: {
            nextEl: btnNext,
            prevEl: btnPrev
          },
          breakpoints: {
            360: {
              slidesPerView: 2
              // slidesPerGroup: 2
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 12
              // slidesPerGroup: 1
            },
            1500: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }
        }
      );
    })
  }
};
